<template>
  <div class="bg-gray-50 dark:bg-gray-900 flex items-center justify-center flex-grow">
    <div class="text-center">
      <h1 class="text-6xl font-bold text-gray-900 dark:text-white mb-4">
        {{ $t("notFound.title") }}
      </h1>
      <p class="text-xl text-gray-600 dark:text-gray-400 mb-8">{{ $t("notFound.message") }}</p>
      <router-link
        to="/"
        class="inline-block px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
      >
        {{ $t("notFound.backToHome") }}
      </router-link>
    </div>
  </div>
</template>

<script setup>
// 404 Not Found page
</script>
